import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { queryClient } from '@/shared/lib/tanstack'
import { CLAIMS_QUERY_KEYS } from '@/shared/constants/cache'
import { updatePetClaim } from '@/services/claims.services'
import type { UpdatePetClaimBody } from '@/services/claims.services'

export function useUpdatePetClaim(claimId: string) {
  const { i18n } = useTranslation()

  return useMutation({
    mutationFn: async (body: UpdatePetClaimBody) => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return updatePetClaim(token, i18n.language, claimId, body)
    },
    onSuccess: (claim) => {
      queryClient.setQueryData(CLAIMS_QUERY_KEYS.petDetail(claimId), claim)
      queryClient.invalidateQueries({ queryKey: CLAIMS_QUERY_KEYS.petLists })
      // Invoices may have been replaced
      queryClient.invalidateQueries({
        queryKey: CLAIMS_QUERY_KEYS.petDocuments(claimId),
      })
    },
    onError: console.error,
  })
}
